import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs, Headers, Http, Connection, RequestOptions } from '@angular/http';
import { API_ENDPOINTS } from '../configuration/api-endpoints';
import { PopupService } from './pop-up.service';
import { StorageService } from './storage.service';
import { CONFIGURATION } from '../../shared/configuration/configuration';
import { URL_SERVICE } from 'environments/environment';
import { Observable } from 'rxjs';
import saveAs from "file-saver";

@Injectable()
export class FileService {

    vLoadingStatus: boolean;

    vFiles = [];
    vMultipleFiles = [];
    vNewMultipleFiles = [];

    constructor(
        private _http: Http,
        private _popupService: PopupService,
        private _storageService: StorageService
    ) {
        this.vLoadingStatus = false;
    }

    getFileLists() {
        return this.vFiles;
    }

    getMultipleFilesList() {
        return this.vMultipleFiles;
    }

    getNewMultipleFilesList() {
        return this.vNewMultipleFiles;
    }

    isLoading() {
        return this.vLoadingStatus;
    }

    validateUploadedFile(file) {
        if (file === undefined) {
            return false;
        }
        if (file.size > CONFIGURATION.FILE.MAX_SIZE || (file.type !== "image/jpeg" && file.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
            return false;
        }
        if (this.vFiles.some(x => x === file.name)) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Please provide file with another name', '', false, false);
            return false;
        }
        return true;
    }

    getSignedRequest(file, pModule, pAttachType, pReferenceID, pRecordID) {
        this.vLoadingStatus = true;
        let endpoint = API_ENDPOINTS.FILE.UPLOAD + '?file-name=' + encodeURIComponent(file.name) + '&file-type=' + file.type + '&module=' + pModule + '&reference-id=' + pReferenceID + '&attach-type=' + pAttachType;
        this._http.get(endpoint).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                //console.log("**********"+vResponseData);
                this.uploadFile(file, vResponseData.data.signedRequest, pModule, pAttachType, pRecordID);

            },
            (error) => {
                //alert('test 1234');
                this.vLoadingStatus = false;
                console.log(error);
                this.deleteAddedAttachment(pAttachType);
            }
        );
    }

    getSignedDownloadRequest(fileName, pModule, pAttachType, pReferenceID) {
        this.vLoadingStatus = true;
        let endpoint = API_ENDPOINTS.FILE.DOWNLOAD + '?file-name=' + encodeURIComponent(fileName) + '&module=' + pModule + '&reference-id=' + pReferenceID + '&attach-type=' + pAttachType;
        console.log("initiate download");
        this._http.get(endpoint).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);
                // window.open(vResponseData.data.signedRequest,'_blank');
                window.location.href = vResponseData.data.signedRequest;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
            }
        );
    }

    getMiscSignedDownloadRequest(fileName) {
        this.vLoadingStatus = true;
        let endpoint = API_ENDPOINTS.FILE.DOWNLOAD_MISC + '?file-name=' + encodeURIComponent(fileName) + '&module=PlantMap_Invoice';
        console.log("initiate download misc");
        this._http.get(endpoint).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);
                // window.open(vResponseData.data.signedRequest,'_blank');
                window.location.href = vResponseData.data.signedRequest;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
            }
        );
    }

    getPlantMapSignedDownloadRequest(fileName) {
        this.vLoadingStatus = true;
        let endpoint = API_ENDPOINTS.FILE.DOWNLOAD_PLANTMAP + '?file-name=' + encodeURIComponent(fileName) + '&module=PlantMap';
        console.log("initiate download plantmap");
        this._http.get(endpoint).subscribe(
            (response) => {
                this.vLoadingStatus = false;
                let vResponseData: any = response;
                console.log(vResponseData);
                // window.open(vResponseData.data.signedRequest,'_blank');
                window.location.href = vResponseData.data.signedRequest;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
            }
        );
    }



    uploadFile(file, signedRequest, pModule, pAttachType, pRecordID) {
        this.vLoadingStatus = true;
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', signedRequest, true);
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    this.vLoadingStatus = false;
                    if (pModule === 'PlantMap') {
                        this._storageService.setSessionItem(pModule + 'Files', JSON.stringify(this.vFiles));
                        this.createPlantmapAttachmentRestricted(file.name, pAttachType, pRecordID);
                    } else if (pModule === 'nce') {
                        this.createNCEAttachment(pRecordID, pAttachType, file.name, pModule);
                    }
                }
                else {
                    console.log(xhr.statusText);
                    this.vLoadingStatus = false;
                    this.openErrorPopup();
                    this.deleteAddedAttachment(pAttachType);
                }
            }
        };
        xhr.send(file);
    }

    createPlantmapAttachmentRestricted(pFileName, pAttachType, pRecordID) {
        var xData = {
            plant_record_id: pRecordID,
            file_name: pFileName
        }

        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.PLANT_MAP.CREATE_PLANTMAP_ATTACHMENT, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                this.openErrorPopup();
                this.deleteAddedAttachment(pAttachType);
            }
        );
    }

    createNCEAttachment(pRecordID, pAttachType, pFileName, pModule) {
        let xData = {
            nce_record_id: pRecordID,
            attach_type: pAttachType,
            file_name: pFileName
        };
        this._storageService.setSessionItem(pModule + 'Files', JSON.stringify(this.vFiles));
        this._storageService.setSessionItem(pModule + 'MultipleFiles', JSON.stringify(this.vMultipleFiles));
        this._storageService.setSessionItem(pModule + 'NewMultipleFiles', JSON.stringify(this.vNewMultipleFiles));
        this.vLoadingStatus = true;
        this._http.post(API_ENDPOINTS.NCE.CREATE_ATTACHMENT, xData).subscribe(
            (response) => {
                this.vLoadingStatus = false;
            },
            (error) => {
                this.vLoadingStatus = false;
                console.log(error);
                this.openErrorPopup();
                this.deleteAddedAttachment(pAttachType);
            }
        );
    }

    deleteAddedAttachment(pAttachType: string) {
        if (pAttachType === 'sketch') {
            this.vFiles[0] = '';
        } else if (pAttachType === 'schedule') {
            this.vFiles[1] = ''
        } else if (pAttachType === 'support') {
            this.vFiles[2] = ''
        } else if (pAttachType === 'plantmap') {
            this.vMultipleFiles.splice(this.vMultipleFiles.length - 1, 1);
        }
        else if (this.vFiles.length > 0) {
            this.vFiles.splice(this.vFiles.length - 1, 1);
        }
    }

    uploadMultipleFile(file, pModule, pAttachType, pReferenceID, pRecordID) {
        return new Promise((resolve, reject) => {
            this.vLoadingStatus = true;
            this._http.get(API_ENDPOINTS.FILE.UPLOAD + '?file-name=' + encodeURIComponent(file.name) + '&file-type=' + file.type + '&module=' + pModule + '&reference-id=' + pReferenceID + '&attach-type=' + pAttachType).subscribe(
                (response) => {
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    let signedRequest = vResponseData.data.signedRequest;

                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', signedRequest, true);
                    xhr.setRequestHeader('Content-Type', file.type);
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                let xData = {
                                    nce_record_id: pRecordID,
                                    attach_type: pAttachType,
                                    file_name: file.name
                                };

                                this._http.post(API_ENDPOINTS.NCE_ADMIN.CREATE_ATTACHMENT, xData).subscribe(
                                    (response) => {
                                        this.vLoadingStatus = false;
                                        console.log(response);
                                        resolve();
                                    },
                                    (error) => {
                                        this.vLoadingStatus = false;
                                        console.log(error);
                                        this.openErrorPopup();
                                        reject();
                                    }
                                );
                            }
                            else {
                                this.vLoadingStatus = false;
                                this.openErrorPopup();
                                reject();
                            }
                        }
                    };
                    xhr.send(file);
                },
                (error) => {
                    console.log(error);
                    this.vLoadingStatus = false;
                    reject();
                }
            );
        });
    }

    sequentialMultipleUpload(files, pModule, pAttachType, pReferenceID, pRecordID) {
        var promise = Promise.resolve(null);
        files.forEach((value) => {
            promise = promise.then(() => {
                return this.uploadMultipleFile(value, pModule, pAttachType, pReferenceID, pRecordID);
            });
        });
        return promise;
    }

    deleteFiles(pReferenceID: string, pModule: string, pAttachType?: string, pFileName?: string) {
        pAttachType = pAttachType === undefined ? '' : pAttachType;
        pFileName = pFileName === undefined ? '' : pFileName;

        console.log(pFileName);

        var promise = this._http.get(API_ENDPOINTS.FILE.DELETE_FILES + '?module=' + pModule + '&reference-id=' + pReferenceID + '&attach-type=' + pAttachType + '&file-name=' + encodeURIComponent(pFileName));
        this.vLoadingStatus = true;
        let p = new Promise((resolve, reject) => {
            promise.subscribe(
                (response) => {
                    this.vLoadingStatus = false;
                    let vResponseData: any = response;
                    console.log(vResponseData);
                    resolve();
                },
                (error) => {
                    this.vLoadingStatus = false;
                    console.log(error);
                    reject();
                });
        });
        return p;
    }

    openErrorPopup() {
        this._popupService.openPopup('confirmation', {
            title: 'Error',
            message: 'Upload unsuccessful, please try again',
            secondLineMessage: '',
            isCheckedImage: false,
            buttons: {
                CANCEL: {
                    text: 'Close',
                    function: () => {
                        this._popupService.closePopup();
                    }
                }
            }
        }
        );
    }

    uploadPlantMapRestrictedAreaAttachmentToDMS(file, plantMapRecordId) {
        const metaData = { incidentid: 'k124', worklogid: 'W123' };
        const formData = new FormData();
        formData.append('fileAttachment', file);
        formData.append('fileName', file.name);
        formData.append('appName', 'PRP');
        formData.append('userGroup', 'PRP System Service Account');
        formData.append('metaDataInfo', JSON.stringify(metaData));
        formData.append('file', file.name);
        formData.append('category', 'common');

        // Encode the username and password for Basic Auth
        const encodedCredentials = btoa(`dmsapi:dmsapi123`);

        const headers = new Headers({
            'Authorization': `Basic ${encodedCredentials}`,
            // No need to set Content-Type for FormData, it's handled automatically
        });
        this._http.post(URL_SERVICE[CONFIGURATION.modeEnv].DMS_UPLOAD_URL, formData, { headers }).subscribe(
            response => {
                console.log('Upload successful:', response);
                this._storageService.setSessionItem('PlantMap ' + 'Files', JSON.stringify(this.vFiles));
                this.createPlantmapAttachmentRestricted(file.name, 'restricted_area', plantMapRecordId);
            },
            error => {
                console.error('Upload failed:', error);
            }
        );;
    }

    downloadPlantMapRestrictedAreaAttachmentFromDMS(fileName) {
        let bdy = {
            "fileName": fileName,
            "userGroup": "PRP System Service Account"
        }

        // Encode the username and password for Basic Auth
        const encodedCredentials = btoa(`dmsapi:dmsapi123`);

        let HTTPOptions: Object = {
            headers: new Headers({
                'Authorization': `Basic ${encodedCredentials}`,
                // No need to set Content-Type for FormData, it's handled automatically
            }),
            responseType: 2
        }

        this._http.post(URL_SERVICE[CONFIGURATION.modeEnv].DMS_DOWNLOAD_URL, bdy, HTTPOptions).subscribe((response: any) => {
            const blob = new Blob([response], {
                type: 'application/pdf'
            });
            saveAs(blob, fileName)
        }
        )
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/file.service.ts